import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Stack,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import WarehouseService from '../../services/warehouse.service';

const WarehouseList: React.FC = () => {
  const navigate = useNavigate();
  const [warehouses, setWarehouses] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const fetchWarehouses = async () => {
    try {
      setLoading(true);
      const response = await WarehouseService.getAll({
        populate: '*',
        'pagination[pageSize]': 100,
      });
      setWarehouses(response.data?.data || []);
    } catch (error) {
      console.error('Error fetching warehouses:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Are you sure you want to delete this warehouse?')) {
      try {
        await WarehouseService.delete(id);
        fetchWarehouses();
      } catch (error) {
        console.error('Error deleting warehouse:', error);
      }
    }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Warehouses</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/warehouses/create')}
        >
          New Warehouse
        </Button>
      </Stack>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>Manager</TableCell>
                <TableCell>Capacity</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {warehouses.map((warehouse) => (
                <TableRow key={warehouse.id} hover>
                  <TableCell>{warehouse.attributes?.code}</TableCell>
                  <TableCell>{warehouse.attributes?.name}</TableCell>
                  <TableCell>{warehouse.attributes?.city || '-'}</TableCell>
                  <TableCell>{warehouse.attributes?.country || '-'}</TableCell>
                  <TableCell>
                    {warehouse.attributes?.manager?.data
                      ? `${warehouse.attributes?.manager?.data?.attributes?.firstName} ${warehouse.attributes?.manager?.data?.attributes?.lastName}`
                      : '-'}
                  </TableCell>
                  <TableCell>{warehouse.attributes?.capacity || '-'}</TableCell>
                  <TableCell>
                    <Chip
                      label={warehouse.attributes?.isActive ? 'Active' : 'Inactive'}
                      size="small"
                      color={warehouse.attributes?.isActive ? 'success' : 'default'}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={() => navigate(`/warehouses/${warehouse.id}`)}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleDelete(warehouse.id)}
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!loading && warehouses.length === 0 && (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary">
            No warehouses found
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default WarehouseList;

